import { shuffleArray } from "../../helper/shuffleArray";
import Main from "../../Main";
import { EnumEventBus, EventBus } from "../../managers/EventBus";
import { WINNING_MULTIPLIER_TABLE, fireworkObject } from "../../types/Config";
import { WFireworkInt } from "../../types/Interface";
import Firework from "../firework/FireworkController";
import WinningIcon from "../WinningIcon";


export default class GridFactory {
  private Main = Main.getInstance();
  private EventBus = EventBus;
  private hand: number[];
  private winningIconList: number[];
  private yOffset: number;
  grid: (Firework | WinningIcon)[][] = [[], [], [], []];
  newHandTime;
  winningFireworks: WFireworkInt[] = [];
  initialHand: boolean;
  totalMultiplier: number = 1;
  constructor(hand, yOffset: number, initialHand: boolean) {
    this.hand = hand;
    this.initialHand = initialHand;
    this.yOffset = yOffset;
    this.newHandTime = Date.now();
    this.generateWIconList();
    this.generateGrid();
    this.calcTotalMultiplier();
  }
  calcTotalMultiplier() {
    if (this.initialHand) {
      return
    }
    const tMulti = this.hand.slice(-5).map((wIA, wIAIndex) => WINNING_MULTIPLIER_TABLE[wIAIndex][wIA]).reduce((tMulti, multi) => tMulti + multi, 0)
    const totalMulti = Number(tMulti.toFixed(2));
    this.totalMultiplier = totalMulti;
  }
  generateWIconList() {
    let list: number[] = []
    this.hand.slice(-5).forEach((wIA, wIAIndex) => {
      for (let i = 0; i < wIA; i++) {
        list.push(wIAIndex)
      }
    })
    this.winningIconList = shuffleArray(list);
  }
  generateGrid() {
    const dim = this.Main.getDim();
    const grd = Array(4).fill(Array(4).fill("e"));
    let i = 0;//for test
    grd.forEach((c, cI) => c.forEach((_, rI) => {
      i++;//for test
      const x = (dim.width / 2) - 200 + 135 * rI;
      const y = (dim.height / 2) - 190 + 128 * cI + this.yOffset;
      const fIndex = this.hand[i];
      const fw = new Firework(fIndex, x, y, cI, rI);
      fw.setInteractivity(!this.initialHand);
      this.grid[cI][rI] = fw;
      this.calculateWinningFw(fIndex, fw);
    }))
  }
  emitWinningFirework(index: number) {
    this.EventBus.emit(EnumEventBus.updateWFireworkTexture, index)
  }
  calculateWinningFw(fIndex: number, firework: Firework) {
    const firstNumber = this.hand[0];
    const winningInfo = fireworkObject[firstNumber];
    const currInfo = fireworkObject[fIndex];
    this.emitWinningFirework(firstNumber);
    if (winningInfo.type == currInfo.type || winningInfo.color == currInfo.color) {
      const wIconIndex = this.winningIconList.shift() || 0;
      firework.setWinIconIndex(wIconIndex);
      const wFirework: WFireworkInt = {
        firework,
        isSameType: winningInfo.type == currInfo.type,
        isSameColor: winningInfo.color == currInfo.color
      }
      this.winningFireworks.push(wFirework);
    }
  }
}